import { DateTime } from "luxon";

export function swapTimezones(date, toTz) {
  const strippedTime = DateTime.fromISO(date, { setZone: true }).toISO({ includeOffset: false })
  const toTime = DateTime.fromISO(strippedTime, { zone: toTz });
  return toTime;
}